export default __webpack_public_path__ + "static/media/640_private01-es-mobile.756d29ae.png";